import { Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { Filter, FilterOperation } from "src/app/core/jsonapi/filter";
import { FilterBuilder } from "src/app/core/jsonapi/filters-builder";
import { IParamsCollection } from "src/app/core/jsonapi/interfaces/params-collection";
import { Service } from "src/app/core/jsonapi/service";
import { CaseTypeCaseMode } from "../_types/case-type-case-mode";

@Injectable({
    providedIn: 'root',
})
export class CaseTypeCaseModeService extends Service<CaseTypeCaseMode> {
    public override type = 'caseTypeCaseModes';
    public override url = 'attendance/caseTypeCaseModes';

    /** Ids de los modos de expediente relacionados con un tipo de daño. */
    public async loadModeIdsFor(caseTypeId: string): Promise<string[]> {
        let response = await firstValueFrom(this.all(this.paramsFor(caseTypeId)));
        return response.data
            .map((relation: CaseTypeCaseMode) => relation.caseModeId)
            .filter((id: string | undefined) => !!id) as string[];
    }

    /**
     * Deja el tipo relacionado exactamente con los modos indicados: borra las relaciones que
     * tenga e inserta las nuevas. El borrado es logico, asi que las filas viejas quedan con
     * Deleted = 1 y el indice unico de la tabla las ignora.
     */
    public async replaceForCaseType(caseTypeId: string, caseModeIds: string[]): Promise<void> {
        let existing = await firstValueFrom(this.all(this.paramsFor(caseTypeId)));
        for (const relation of existing.data) {
            await firstValueFrom(this.delete(relation.id));
        }
        for (const caseModeId of caseModeIds) {
            let relation = new CaseTypeCaseMode();
            relation.caseTypeId = caseTypeId;
            relation.caseModeId = caseModeId;
            await firstValueFrom(this.save(relation));
        }
    }

    private paramsFor(caseTypeId: string): IParamsCollection {
        return {
            filter: FilterBuilder.fromObject({
                caseTypeId: new Filter(FilterOperation.equals, 'caseTypeId', '', caseTypeId)
            }).build(),
            page: { number: 1, size: 200 }
        };
    }
}
